import { useState } from 'react'
import { useNavigate } from "react-router-dom";
import validator from 'validator'

import { forgotPassword } from "../../utils/CognitoAuth"

import { Helmet } from 'react-helmet-async';

const ForgotPassword = () => {
    const navigate = useNavigate()

    const [email, setEmail] = useState("")
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (validator.isEmpty(email)) {
            setError(true)
            setErrorMessage("Email is required")
        } else if (!validator.isEmail(email)) {
            setError(true)
            setErrorMessage("Please enter valid email")
        } else {
            setError(false)

            try {
                const result = await forgotPassword(email)
                navigate("/reset-password")
            } catch (e) {
                setError(true)
                setErrorMessage(e.message)
            }
        }
    }

    return (
        <div className='relative flex flex-col min-h-screen overflow-hidden'>
            <Helmet>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <div className="w-full p-6 mx-auto bg-white rounded-md shadow-md lg:max-w-xl">
                <div className='font-bold text-2xl'>Reset Password</div>

                <form onSubmit={handleSubmit}>
                    <div className='mb-2'>
                        <input
                            className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
                            name="email"
                            placeholder="Enter email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    {error && (
                        <div className='italic text-sm text-red-600'>{errorMessage}</div>
                    )}
                    <div className="mt-6">
                        <button type="submit" className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-indigo-700 rounded-md hover:bg-indigo-600 focus:outline-none focus:bg-indigo-600">
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ForgotPassword